import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-expression-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './expression-page.html',
})
export class ExpressionPage {}
